var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-table',{staticStyle:{"width":"100%","text-align":"center"},attrs:{"height":"400","border":"","fit":"","data":_vm.currentRecordDetails}},[_c('el-table-column',{attrs:{"prop":"name","label":"菜名","width":"180"}}),_c('el-table-column',{attrs:{"prop":"price","label":"价格","width":"180"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }